export default "__VITE_ASSET__34mSXxYS__"